var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPsiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6348 17.0003C11.6348 12.7472 14.9627 9.23755 19.2098 9.01163L36.9072 8.07024L53.8056 8.99901C58.0469 9.23212 61.3666 12.7393 61.3666 16.9869V60.3262C61.3666 64.7445 57.7849 68.3262 53.3666 68.3262H19.6348C15.2165 68.3262 11.6348 64.7445 11.6348 60.3262V17.0003Z",
    stroke: "#003468",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4453 11.2069C22.4453 10.3195 22.5554 9.46083 22.7611 8.6469C23.7604 4.69399 27.0161 1.79688 30.8782 1.79688H42.122C45.9842 1.79688 49.2399 4.69399 50.2391 8.6469C50.4449 9.46083 50.5549 10.3195 50.5549 11.2069C50.5549 12.9392 49.1506 14.3436 47.4183 14.3436H25.582C23.8496 14.3436 22.4453 12.9392 22.4453 11.2069Z",
    fill: "#003468"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4824 39.4316L32.6035 46.9511C32.9987 47.3171 33.6128 47.3043 33.9924 46.9221L50.8991 29.9036",
    stroke: "#003468",
    strokeWidth: 7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsiIcon);
export default __webpack_public_path__ + "static/media/psiIcon.8515228bcfce8fe97c5073f74de3572f.svg";
export { ForwardRef as ReactComponent };